// Mutation Observer - On Element added to DOM
// -----------------------------------------------------------------------------

(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);

$(document).ready(function(){

  //
  $('<p>You will receive an email once your account is confirmed or should we require further details we will contact you.</p>').insertAfter('[data-title="request-trade-account"] h1');

  // Hack for bss app
  ready('.Polaris-Button', function(element) {
    $('.Polaris-Button').parent().removeAttr('name');
  });
  ready('.bss-b2b-customer-portal-nt-checkout-btn', function(element) {
    $('.bss-b2b-customer-portal-nt-checkout-btn').removeAttr('name');
  });
  

  // Header Drop down

  $('.header__subdropdown > div > ul > li').click(function(){
    $(this).siblings().find('details').removeAttr('open');
  });

  function uspBar(){
    $(".header__usp-bar .page-width").slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 9999,
            settings: "unslick"
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              mobileFirst:true
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst:true
            }
          }
        ]
    });
  }
  uspBar();
  $(window).resize(function(){
    if ( $(window).width() < 750 ) {
      uspBar();
    }
  });



});
